"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateICOorCUR = exports.isICO = void 0;
var TYPE_ICON = 1;
var SIZE_HEADER = 2 + 2 + 2;
var SIZE_IMAGE_ENTRY = 1 + 1 + 1 + 1 + 2 + 2 + 4 + 4;
function isICO(buffer) {
  if (buffer.readUInt16LE(0) !== 0) {
    return false;
  }
  var type = buffer.readUInt16LE(2);
  return type === TYPE_ICON;
}
exports.isICO = isICO;
function getSizeFromOffset(buffer, offset) {
  var value = buffer.readUInt8(offset);
  return value === 0 ? 256 : value;
}
function getImageSize(buffer, imageIndex) {
  var offset = SIZE_HEADER + imageIndex * SIZE_IMAGE_ENTRY;
  return {
    width: getSizeFromOffset(buffer, offset),
    height: getSizeFromOffset(buffer, offset + 1)
  };
}
function calculateICOorCUR(buffer) {
  var nbImages = buffer.readUInt16LE(4);
  var result = {
    images: [getImageSize(buffer, 0)]
  };
  if (nbImages === 1) {
    return result;
  }
  for (var i = 1; i < nbImages; i += 1) {
    result.images.push(getImageSize(buffer, i));
  }
  return result;
}
exports.calculateICOorCUR = calculateICOorCUR;